import Enum from './Enum.js';

export default class Permission extends Enum {
  static DASHBOARD_READ = new Permission('DASHBOARD_READ', 'ダッシュボード閲覧');
  static GENERAL_INFORMATION_READ = new Permission('GENERAL_INFORMATION_READ', '基本情報閲覧');
  static GENERAL_INFORMATION_WRITE = new Permission('GENERAL_INFORMATION_WRITE', '基本情報編集');
  static DEPARTMENT_READ = new Permission('DEPARTMENT_READ', '店舗/部署閲覧');
  static DEPARTMENT_WRITE = new Permission('DEPARTMENT_WRITE', '店舗/部署編集');
  static USER_READ = new Permission('USER_READ', 'スタッフ閲覧');
  static USER_WRITE = new Permission('USER_WRITE', 'スタッフ編集');
  static RESULT_READ = new Permission('RESULT_READ', '評価一覧閲覧');
  static SKILL_READ = new Permission('SKILL_READ', 'スキルマップ閲覧');
  static SKILL_WRITE = new Permission('SKILL_WRITE', 'スキルマップ編集');
  static KPI_READ = new Permission('KPI_READ', '数値目標閲覧');
  static KPI_WRITE = new Permission('KPI_WRITE', '数値目標編集');
  static EVALUATION_TERM_READ = new Permission('EVALUATION_TERM_READ', '評価期間閲覧');
  static EVALUATION_TERM_WRITE = new Permission('EVALUATION_TERM_WRITE', '評価期間編集');
  static FINAL_EVALUATION_READ = new Permission('FINAL_EVALUATION_READ', '最終評価閲覧');
  static FINAL_EVALUATION_WRITE = new Permission('FINAL_EVALUATION_WRITE', '最終評価編集');
  static GRADE_READ = new Permission('GRADE_READ', '等級閲覧');
  static GRADE_WRITE = new Permission('GRADE_WRITE', '等級編集');
  static SALARY_READ = new Permission('SALARY_READ', '個人給与マスタ閲覧');
  static SALARY_WRITE = new Permission('SALARY_WRITE', '個人給与マスタ編集');
  static PAYROLL_RANK_READ = new Permission('PAYROLL_RANK_READ', '評価ランク・昇降給規定閲覧');
  static PAYROLL_RANK_WRITE = new Permission('PAYROLL_RANK_WRITE', '評価ランク・昇降給規定編集');
  static SALARY_REVIEW_READ = new Permission('SALARY_REVIEW_READ', '給与計算閲覧');
  static SALARY_REVIEW_WRITE = new Permission('SALARY_REVIEW_WRITE', '給与計算編集');
  static BONUS_READ = new Permission('BONUS_READ', '賞与計算閲覧');
  static BONUS_WRITE = new Permission('BONUS_WRITE', '賞与計算編集');
  static INTERVIEW_RECORD_READ = new Permission('INTERVIEW_RECORD_READ', '面談記録閲覧');
  static INTERVIEW_RECORD_WRITE = new Permission('INTERVIEW_RECORD_WRITE', '面談記録編集');
}
